import React, { useRef, useState } from "react";
import styled from "@emotion/styled";
import { IconButton, Typography } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { Info } from "@mui/icons-material";

const HtmlTooltip = styled(({ className, ...props }: TooltipProps & { is_details_mobile: boolean }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme, is_details_mobile }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: "#e6e7f7",
        marginTop: "-2px",
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#e6e7f7",
        maxWidth: 220,
        border: "1px solid #e6e7f7",
        borderRadius: "12px",
        marginBottom: "0 !important",
        marginTop: is_details_mobile ? "0 !important" : "auto",
    },
}));

export default function PopperComponent({ text = "", isDetails = false }) {
    const arrowRef2 = useRef(null);
    const [openTolltip, setShowTooltip] = useState(false);
    return (
        <>
            <HtmlTooltip
                is_details_mobile={isDetails}
                enterDelay={0}
                leaveDelay={100}
                leaveTouchDelay={5000}
                open={openTolltip}
                onOpen={() => setShowTooltip(true)}
                onClose={() => setShowTooltip(false)}
                placement={isDetails ? "bottom-end" : "top-end"}
                title={
                    <React.Fragment>
                        <Typography variant="caption" color={"#1C1D38"} fontFamily={"IliaOpenSans"}>
                            {text}
                        </Typography>
                    </React.Fragment>
                }
            >
                <IconButton
                    ref={arrowRef2}
                    onClick={() => {
                        setShowTooltip(true);
                    }}
                >
                    <Info style={{ color: "#9192AD" }} />
                </IconButton>
            </HtmlTooltip>
        </>
    );
}
